/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import template from './order-analysis-page.component.html';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';

type OrderAnalysisTab = 'charts' | 'stats' | 'tags' | 'reports' | 'traffic' | 'location';

@Component({
  standalone: false,
  selector: 'adn-order-analysis-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() state: SignalAdminResourcePageState<any>;
  private _isNewDirect: boolean | undefined;
  private _chartCurrencyDirect: any;

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  @Input()
  set chartCurrency(value: any) {
    this._chartCurrencyDirect = value;
  }

  get chartCurrency(): any {
    return this._chartCurrencyDirect;
  }

  effectiveIsNew = false;
  tagModel: {model: any} = {model: null};
  activeTab: OrderAnalysisTab = 'charts';
  statsLoaded = false;
  tagsLoaded = false;
  reportsLoaded = false;
  trafficLoaded = false;
  locationLoaded = false;
  canSeeReports = false;
  notesSaveTarget: any;

  constructor(@Inject(LocalUserPermissions) private readonly LocalUserPermissions: any) {
    const perms = LocalUserPermissions.getAllVisPermissions();
    this.canSeeReports = LocalUserPermissions.getAnyVisibility().RUN_REPORTS === true || perms.AX_ADVERTISER;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.model || changes.state) {
      this.tagModel = {model: this.model};
      this.notesSaveTarget = this.state ? this.state.notesSaveTarget() : this.model;
    }
  }

  selectTab(tab: OrderAnalysisTab): void {
    this.activeTab = tab;
    if (tab === 'stats') {
      this.statsLoaded = true;
    } else if (tab === 'tags') {
      this.tagsLoaded = true;
    } else if (tab === 'reports') {
      this.reportsLoaded = true;
    } else if (tab === 'traffic') {
      this.trafficLoaded = true;
    } else if (tab === 'location') {
      this.locationLoaded = true;
    }
  }

}
